import { useParams } from "react-router-dom";

import Heading from "../../shared/ui/Typography/Heading";
import Text from "../../shared/ui/Typography/Text";
import { ClientContactsEditor } from "../../features/clientContacts";

// ClientContactsEditScreen — route landing for
// /clients/:clientId/contacts/edit. Mounts under MainLayout. Thin
// composition wrapper that reads :clientId from the URL and hands it
// to the feature widget. All state owned by the widget.

function ClientContactsEditScreen() {
  const { clientId } = useParams();

  return (
    <section
      className="feature-client-contacts"
      id="Csection"
      tabIndex="-1"
    >
      <div className="container">
        <header className="feature-client-contacts__header">
          <Heading level={1} variant="page">
            Канали зв'язку клієнта
          </Heading>
          <Text as="p" size="sm" tone="secondary">
            Telegram, додаткові телефони, email. Кожен рядок зберігається
            окремо.
          </Text>
        </header>

        <ClientContactsEditor clientId={clientId} />
      </div>
    </section>
  );
}

export default ClientContactsEditScreen;
